import styled from "styled-components";
import { InviteStudyDTO } from "../config/type";

type BackgroundImageContainerProps = {
  inviteStudyInfo: InviteStudyDTO;
};

export default function BackgroundImageContainer({
  inviteStudyInfo,
}: BackgroundImageContainerProps) {
  const studyFieldList = [
    "전공과목",
    "자기계발",
    "어학",
    "자격증",
    "면접",
    "개발",
    "디자인",
    "취미",
    "기타",
  ];
  const getFontSize = (text: string) => {
    if (text.length <= 10) {
      return {};
    } else if (text.length > 10 && text.length < 12) {
      return { fontSize: "1.5rem" };
    } else if (text.length >= 12 && text.length < 15) {
      return { fontSize: "1.2rem" };
    }
    return { fontSize: "1.1rem" };
  };
  const getDayOfWeek = (day: number) => {
    switch (day) {
      case 0:
        return "월";
      case 1:
        return "화";
      case 2:
        return "수";
      case 3:
        return "목";
      case 4:
        return "금";
      case 5:
        return "토";
      case 6:
        return "일";
    }
  };
  return (
    <BackgroundImageDiv
      className="flex justify-center rounded-full w-[262px] h-[262px] border-[10px] border-[#FF3030] relative"
      style={{
        background: `url('${inviteStudyInfo.studyImageUrl}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute rounded-[10px] text-xs bg-[#E7EBEF] py-1 px-2 mt-[60px]">
        {studyFieldList[inviteStudyInfo.studyField] || "기타"}
      </div>
      <div className="absolute flex text-[28px] top-1/2 translate-y-[-50%] items-center flex-col">
        <div
          className="text-white font-semibold"
          style={getFontSize(inviteStudyInfo.studyName)}
        >
          {inviteStudyInfo.studyName}
        </div>
        <div className="absolute text-sm text-[#A4ADBC] mt-[42px] text-center">
          <div>{inviteStudyInfo.totalWeeks}주차</div>
          <div className="whitespace-nowrap">
            매주{" "}
            {inviteStudyInfo?.daysOfWeek.map((d) => getDayOfWeek(d)).join(", ")}
            요일
          </div>
        </div>
      </div>
    </BackgroundImageDiv>
  );
}
const BackgroundImageDiv = styled.div`
  &:before {
    content: "";
    border-radius: 50%;
    opacity: 0.5;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: #000;
  }
`;
